import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { NgbModule } from '@ng-bootstrap/ng-bootstrap';

import { WelcomeRoutingModule } from './welcome-routing.module';
import { WelcomeComponent } from './welcome.component';
import { IntroVideoComponent } from './intro-video/intro-video.component';
import { IntroVideoWrapperComponent } from './intro-video/intro-video-wrapper.component';
import { BunnyIntroVideoComponent } from './bunny-intro-video/bunny-intro-video.component';
import { VideoWrapperComponent } from '../main-game/after-main-game/video-wrapper.component';
import { BunnyVideoComponent } from '../main-game/bunny-video/bunny-video.component';
import { SharedModule } from '../shared/shared.module';
import { AfterMainGameComponent } from '../main-game/after-main-game/after-main-game.component';

@NgModule({
  imports: [
    NgbModule,
    CommonModule,
    WelcomeRoutingModule,
    SharedModule
  ],
  declarations: [
    WelcomeComponent,
    IntroVideoComponent,
    IntroVideoWrapperComponent,
    BunnyIntroVideoComponent,
    AfterMainGameComponent,
    VideoWrapperComponent,
    BunnyVideoComponent
  ]
})
export class WelcomeModule { }
